import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IconButton, Link, TextField } from "@mui/material";
import { red, blue, green, yellow, purple } from "@mui/material/colors";

import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import SlowMotionVideoRoundedIcon from "@mui/icons-material/SlowMotionVideoRounded";
import QuizIcon from "@mui/icons-material/Quiz";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Paper from "@mui/material/Paper";
import NoteAltIcon from "@mui/icons-material/NoteAlt";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  maxWidth: 500,
  bgcolor: "#05102d",
  border: "2px solid gray",
  boxShadow: 24,
  p: 4,
};

const BatchConclutionModal = ({ openRoutine, handleRoutineClose, routine }) => {
  const {
    Chapter,
    Subject,
    Pdf,
    ClassLink,
    examLink,
    answerSheet,
    notice,
    handNote,
  } = routine;
  return (
    <div>
      <Modal
        open={openRoutine}
        onClose={handleRoutineClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            sx={{ padding: "3px" }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            {Subject}

            <TextField
              sx={{
                width: "100%",
                padding: " 3x 5px",
                marginTop: "3px",
              }}
              label={Chapter}
              variant="filled"
              disabled
              color="success"
              focused
            />
          </Typography>
          <hr />
          <Box
            sx={{
              my: "10px",
              mt: "10px",
              display: "grid",
              // placeItems: "center",

              justifyContent: "center",
              gridGap: "12%",
              gridTemplateColumns: " 30px 30px 30px 30px 30px",
            }}
          >
            {ClassLink ? (
              <Link href={ClassLink} target="_blank" underline="none">
                <IconButton sx={{ bgcolor: blue[600] }} size="large">
                  <SlowMotionVideoRoundedIcon
                    sx={{ color: "white" }}
                  ></SlowMotionVideoRoundedIcon>
                </IconButton>
              </Link>
            ) : (
              ""
            )}

            {Pdf ? (
              <Link href={Pdf} target="_blank" underline="none">
                <IconButton sx={{ bgcolor: yellow[900] }} size="large">
                  <PictureAsPdfRoundedIcon
                    sx={{ color: "white" }}
                  ></PictureAsPdfRoundedIcon>
                </IconButton>
              </Link>
            ) : (
              ""
            )}

            {handNote ? (
              <Link href={handNote} target="_blank" underline="none">
                <IconButton sx={{ bgcolor: purple[700] }} size="large">
                  <NoteAltIcon sx={{ color: "white" }}></NoteAltIcon>
                </IconButton>
              </Link>
            ) : (
              ""
            )}
            {examLink ? (
              <Link href={examLink} target="_blank" underline="none">
                <IconButton sx={{ bgcolor: red[700] }} size="large">
                  <QuizIcon sx={{ color: "white" }}></QuizIcon>
                </IconButton>
              </Link>
            ) : (
              ""
            )}
            {answerSheet ? (
              <Link href={answerSheet} target="_blank" underline="none">
                <IconButton sx={{ bgcolor: green[700] }} size="large">
                  <EmojiEventsIcon sx={{ color: "white" }}></EmojiEventsIcon>
                </IconButton>
              </Link>
            ) : (
              ""
            )}
          </Box>
          <hr />
          {ClassLink ? (
            <Typography variant="overline" display="block" gutterBottom>
              নীল🔵 বাটন ক্লাস দেখার জন্য
            </Typography>
          ) : (
            ""
          )}
          {handNote ? (
            <Typography variant="overline" display="block" gutterBottom>
              বেগুনি🟣 বাটন HAND NOTE 'র জন্য
            </Typography>
          ) : (
            ""
          )}
          {Pdf ? (
            <Typography variant="overline" display="block" gutterBottom>
              হলুদ🟡 বাটন লেকচার শীটের জন্য
            </Typography>
          ) : (
            ""
          )}
          {examLink ? (
            <Typography variant="overline" display="block" gutterBottom>
              লাল⭕ বাটন এক্সাম দেওয়ার জন্য
            </Typography>
          ) : (
            ""
          )}
          {answerSheet ? (
            <Typography variant="overline" display="block" gutterBottom>
              সবুজ🟢 বাটন প্রদত্ত এক্সাম এর রেজাল্ট ও উত্তর দেখার জন্য
            </Typography>
          ) : (
            ""
          )}
          {notice && (
            <>
              <hr />

              <Paper
                elevation="24"
                variant="outlined"
                sx={{ backgroundColor: "#ff0000", py: "3px", px: "2px" }}
                rounded
              >
                <Typography
                  sx={{ display: "flex", alignItems: "center", mx: "2px" }}
                  variant="button"
                  display="block"
                  gutterBottom
                >
                  <ErrorOutlineIcon
                    sx={{ mx: "2px", width: "2.5rem", height: "2.5rem" }}
                  />{" "}
                  {notice}
                </Typography>
              </Paper>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default BatchConclutionModal;
